import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import SearchSaveNotification, {SEARCH_SAVE_NOTIFICATION_TYPES} from './search-save-notification.js'

function NotificationNoFiltersApplied({onClose = () => {}, show, portalContainer, className}) {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const APP_NAME = config.get('APP_NAME')

  return (
    <SearchSaveNotification
      className={className}
      portalContainer={portalContainer}
      type={SEARCH_SAVE_NOTIFICATION_TYPES.SYSTEM}
      show={show}
      onClose={onClose}
    >
      {i18n.t(`ADD_FILTER_TO_CREATE_ALERT_${APP_NAME}`)}
    </SearchSaveNotification>
  )
}

NotificationNoFiltersApplied.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  portalContainer: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.object,
  className: PropTypes.string
}

export default NotificationNoFiltersApplied
